import React, { useEffect, useState } from "react";
import { Flex, Select } from "@chakra-ui/react";

const MONTHS = [
  {
    label: "January",
    value: "01",
  },
  {
    label: "February",
    value: "02",
  },
  {
    label: "March",
    value: "03",
  },
  {
    label: "April",
    value: "04",
  },
  {
    label: "May",
    value: "05",
  },
  {
    label: "June",
    value: "06",
  },
  {
    label: "July",
    value: "07",
  },
  {
    label: "August",
    value: "08",
  },
  {
    label: "September",
    value: "09",
  },
  {
    label: "October",
    value: "10",
  },
  {
    label: "November",
    value: "11",
  },
  {
    label: "December",
    value: "12",
  },
];

const CURRENT_YEAR = new Date().getFullYear();

interface DateInputProps {
  filterKey: string;
  updateFilter: (filterKey: string, value: any) => void;
  defaultValue?: any;
}

function DateInput(props: DateInputProps) {
  const [month, setMonth] = useState<number | undefined>(
    props.defaultValue?.split("-")[1]
      ? parseInt(props.defaultValue?.split("-")[1])
      : undefined
  );
  const [year, setYear] = useState<number | undefined>(
    props.defaultValue?.split("-")[0]
      ? parseInt(props.defaultValue?.split("-")[0])
      : undefined
  );

  useEffect(
    () => {
      if (month && year) {
        props.updateFilter(
          props.filterKey,
          `${year}-${month < 10 ? "0" + month : month}`
        );
      }

      if (!month && !year) {
        props.updateFilter(props.filterKey, "");
      }
    },
    // adding props as dependency makes infinite re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [month, year]
  );

  return (
    <Flex gap={2}>
      <Select
        placeholder="Month"
        value={`${month < 10 ? "0" + month : month}`}
        onChange={(e) => setMonth(parseInt(e.target.value))}
      >
        {MONTHS.map((month) => (
          <option key={month.value} value={month.value}>
            {month.label}
          </option>
        ))}
      </Select>
      <Select
        placeholder="Year"
        value={year?.toString()}
        onChange={(e) => setYear(parseInt(e.target.value))}
      >
        {[...Array(5)].map((_, i) => (
          <option key={i} value={CURRENT_YEAR - i}>
            {CURRENT_YEAR - i}
          </option>
        ))}
      </Select>
    </Flex>
  );
}

export default DateInput;
